import resolveImageDomain from '../../data/transformers/resolveImageDomain'
import style from '../../styles/components/componentMap/live'
import VideoPlayer from '../utilities/VideoPlayer'

const Hero = ({ story, withAds }) => {
  const videoData = story?.videoFile?.fields?.videoUrls
    ? Object.entries(story?.videoFile?.fields?.videoUrls)?.find(v => v[0] === 'application/x-mpegURL') ||
      Object.entries(story?.videoFile?.fields?.videoUrls)?.find(v => v[0] === 'video/mp4')
    : []

  const mime = videoData?.[0]
  const url = videoData?.[1]

  return (
    <>
      <div className='hero'>
        {url && (
          <VideoPlayer
            src={url}
            isLive={story?.videoFile?.fields?.isLive}
            type={mime}
            contentfulCategories={story?.categories}
            slug={story?.slug}
            title={story?.title}
            withAds={withAds}
          />
        )}
        {!url && story?.heroImage && (
          <img
            data-testid='hero_image'
            src={`https:${resolveImageDomain(story?.heroImage?.fields?.file?.url)}?q=80&fm=webp`}
          />
        )}
      </div>
      {story?.videoFile?.fields?.isLive && <style>{style}</style>}
    </>
  )
}

export default Hero
